import React from 'react';
import { Input as AntInput } from 'antd';

interface InputFieldProps {
  type: 'text' | 'email' | 'password';
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  [key: string]: any;
}

export const InputField: React.FC<InputFieldProps> = ({
  type,
  placeholder,
  value = '',
  onChange,
  ...props
}) => {
  return (
    <AntInput
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={e => onChange?.(e.target.value)}
      {...props}
    />
  );
};
